/** Category map rows used by the product category selector. */
export interface CategoryOptionLike {
    id: number;
    CategoryID: number;
    CategoryName: string;
    Name: string;
}

/** Options belonging to a single CategoryID group. */
export function getCategoryOptions<T extends {CategoryID: number}>(categories: T[], categoryId: number): T[] {
    return categories.filter(x => x.CategoryID === categoryId);
}

/**
 * Layout threshold for a single category group:
 * fewer than 6 options → tiles; 6 or more → select.
 */
export function shouldUseCategoryTiles(optionCount: number): boolean {
    return optionCount < 6;
}

/** Heading text derived from the first option in the scoped list. */
export function getCategoryName(options: {CategoryName: string}[]): string {
    return options[0]?.CategoryName ?? '';
}

/** Whether the shared selected map id matches this option. */
export function isSelectedCategoryOption(selectedMapId: number, optionId: number): boolean {
    return selectedMapId === optionId;
}

/** Stable React key for a category option. */
export function getCategoryOptionKey(option: {id: number}): number {
    return option.id;
}

/** Resolve a selection only if it belongs to the given option list. */
export function findCategoryOptionById<T extends {id: number}>(options: T[], id: number): T | undefined {
    return options.find(x => x.id === id);
}
